// extracted by mini-css-extract-plugin
export default {"button":"Button_button__8wKcG","primary":"Button_primary__OF2sI","secondary":"Button_secondary__qdH-F"};